module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquarius/aqr_names-abe453f02b2551aa202f90aa6e84c509.gif";